import React from 'react';

export const VolLocRegionsModal = {
  title: 'Region',
  body: (
    <div>
      <p>
        Regional boundaries defined as follows:
      </p>
      <p>
        <p>
          <ul>
            <li>01 - Mediterranean and West Asia</li>
            <li>02 - Africa and Red Sea</li>
            <li>03 - Middle East and Indian Ocean</li>
            <li>04 - New Zealand to Fiji</li>
            <li>05 - Melanesia and Australia</li>
            <li>06 - Indonesia</li>
            <li>07 - Philippines and SE Asia</li>
            <li>08 - Japan, Taiwan, Marianas</li>
            <li>09 - Kuril Islands</li>
            <li>10 - Kamchatka and Mainland Asia</li>
            <li>11 - Alaska</li>
            <li>12 - Canada and Western USA</li>
            <li>13 - Hawaii and Pacific Ocean</li>
            <li>14 - Mexico and Central America</li>
            <li>15 - South America</li>
            <li>16 - West Indies</li>
            <li>17 - Iceland and Arctic Ocean</li>
            <li>18 - Atlantic Ocean</li>
            <li>19 - Antarctica</li>
          </ul>
        </p>
      </p>
    </div>
  ),
};
